module.exports = __webpack_public_path__ + "img/dataset_delete.3225dcdf.png";